import * as React from 'react';

import Button from '@/components/elements/Button/BaseButton';
import { ChargeType } from '@/modelTypes';

import { ResultText, Wrapper } from '../Success/style';

interface QuickChargeTimeoutProps {
  chargeType: ChargeType;
  handleClose: () => void;
}

const QuickChargeTimeout: React.FC<QuickChargeTimeoutProps> = ({
  handleClose,
}) => {
  return (
    <Wrapper>
      <ResultText>
        サーバとの通信が規定時間を超えました。
        <br />
        toreta+ がチャージされている場合がありますので、
        <br />
        「toreta+利用情報」をご確認ください。
      </ResultText>
      <a
        href={import.meta.env.VITE_DMM_TORETA_HISTORY_URL}
        target="_blank"
        rel="noreferrer"
      >
        <Button
          bgColor="primary"
          size={['s', 's', 'm', 'm']}
          width="240px"
          height="56px"
          fontWeight="bold"
          outline
          radius="l"
          onClick={() => handleClose()}
        >
          toreta+利用情報
        </Button>
      </a>
    </Wrapper>
  );
};

export default QuickChargeTimeout;
